import React, { useEffect, useState } from 'react';
import { checkValidity } from '../../shared/utility';
import Input from '../../UI/Input/Input';

const UUIDBlock = (props) => {

    const [formInputElements, setFormInputElements] = useState({
        agentId: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                id: 'agentId',
                placeholder: '',
                maxLength: 101,
            },
            value: props.agentIdValue,
            validation: {
                required: false,
                minlength: 3,
                maxlength: 100,
                nospace: true
            },
            valid: true,
            touched: false,
            label: "AgentID",
            inputType: "Half",
            disabled: false
        },
        uuid:{
            elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'uuid',
                    placeholder: '',
                    maxLength: 101
                },
                value: props.uuidValue,
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 100,
                    nospace: true,
                },
                valid: true,
                touched: false,
                label: "UUID",
                inputType: "Half",
                disabled: false
        }
    })

    useEffect(() => {
        props.clearSearch.current = clearUuid
    },[props.agentIdDisabled])

    const clearUuid = () => {
        const updatedForm = {...formInputElements}

        updatedForm['agentId'].value = ''
        updatedForm['agentId'].touched = false
        updatedForm['agentId'].valid = true

        updatedForm['uuid'].value = ''
        updatedForm['uuid'].touched = false
        updatedForm['uuid'].valid = true

        setFormInputElements(updatedForm)
        props.setFormIsValid(true)
    }

    const inputChangedHandler = (eventReceived, formIdentifier) => {
        let updatedForm = {...formInputElements};

        const updatedFormElement = { ...updatedForm[formIdentifier] };
        updatedFormElement.value = eventReceived.target.value;

        if(eventReceived.target.value) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
            props.errorHandler({message: validation.message});
        } else {
            updatedFormElement.valid = true;
            props.errorHandler(null);
        }
        updatedFormElement.touched = true;
        updatedForm[formIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        if(formIdentifier === 'agentId'){
            props.setAgentId(eventReceived.target.value)
        }else{
            props.setUuid(eventReceived.target.value)
        }
        props.setFormIsValid(formIsValid);
        setFormInputElements(updatedForm);
    }

    const createForm = () => {

        const formsElementsArray =[];

        for(let key in formInputElements) {
            formsElementsArray.push({
                id: key,
                config: formInputElements[key]
            });
        }

        return (
        <>
            <div style={{"display":"flex"}}>
                {formsElementsArray.map((formElement => (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        label={formElement.config.label}
                        changed={(event) => inputChangedHandler(event, formElement.id)}
                        extendedInput={formElement.config.extendedInput}
                        inputType={formElement.config.inputType}
                        disabled={formElement.config.disabled}
                    />
                )))}
            </div>
        </>
        )
        
    }

    return <>
        {createForm()}
    </>

}

export default UUIDBlock;
